<template>
  <div class="home">
    <div class="imagem"></div>
    <div>
      <!-- <Header :path="{name: 'vivo.consulta.home'}" /> -->
      <Header />
    </div>

    <div class="main-holder">
      <busca />
    </div>

    <section class="item-detalhado">
      <template v-if="loadingModelos">
        <div class="loading-modelo">
          <img src="@/assets/imgs/puff.svg" alt="Loading..." />
        </div>
      </template>
      <template v-if="!loadingModelos && cel">
        <div class="nome-do-aparelho">
          <span v-if="cel.prevenda">PRÉ-LANÇAMENTO</span>
          <h1>
            {{ cel.marca.nome }}
            <strong>{{ cel.modelo }}</strong>
          </h1>
        </div>

        <div class="conteudo-principal" v-if="!cel.prevenda">
          <div class="imagem-destaque">
            <celular-detalhado-imagem :imagem="cel.imagem" />
            <!-- <img v-if="!!cel.imagem" :src="cel.imagem" :key="cel.id" />
            <img v-else src="@/assets/vivo-consulta/imagens/generic_phone_teaser.png" />-->
          </div>
          <div class="planos" v-if="cel.tipo === 'smartphone'">
            <template v-if="true">
              <ul class="selecione-planos">
                <li v-for="(p, idx) in btnPlanos" :key="idx">
                  <input
                    type="radio"
                    name="select_planos"
                    v-model="planoSelect"
                    :id="`planos-${p.id}`"
                    :value="p.id"
                  />
                  <label :for="`planos-${p.id}`">{{ p.name }}</label>
                </li>
              </ul>
              <div class="busca-planos">
                <input
                  v-model="inputSearch"
                  type="text"
                  class="input-bp"
                  placeholder="Digite uma palavra chave para filtrar os planos"
                  :disabled="!oncePrePago"
                />
                <img src="@/assets/vivo-consulta/imagens/busca-planos.svg" alt="Busca" />
              </div>
            </template>
            <template v-else>
              <ul class="foco">
                <li>
                  <p>
                    R$
                    <strong>{{ cel.preco | convertMoeda }}</strong>
                  </p>
                  <h4>PREÇO</h4>
                </li>
              </ul>
            </template>
            <div class="lista" v-if="this.planoSelect !== 4">
              <nav>
                <div class="botoes">
                  <button
                    v-if="oncePrePago && this.planoSelect !== 4"
                    @click="handleChangeTab('sva')"
                    :class="listaAtiva == 'sva' ? 'ativo' : ''"
                  >
                    Com SVAs
                  </button>
                  <button
                    v-if="oncePrePago && this.planoSelect !== 4"
                    @click="handleChangeTab('sem')"
                    :class="listaAtiva == 'sem' ? 'ativo' : ''"
                  >
                    Sem SVAs
                  </button>
                </div>
                <div :class="{ 'labels-parcelamento': exibirParcelamento, 'labels': !exibirParcelamento }">
                  <span>Preço</span>
                  <span class="renova">Renova</span>
                  <div class="parcelamento-container" v-if="exibirParcelamento">
                    <div class="parcelamento-title">Parcelamento</div>
                    <div class="parcela-container">
                      <span class="parcelamento-title-item" v-show="exibirParcelamentoTipo">Vivo Itaúcard</span>
                      <span class="parcelamento-title-item">Cartões Caix/Sant/BB</span>
                      <span class="parcelamento-title-item">Demais Cartões</span>
                    </div>
                  </div>
                </div>
              </nav>

              <div class="list-planos" v-if="listaAtiva == 'sva' && this.planoSelect !== 4">
                <p class="title" v-if="oncePrePago">MENSAL</p>
                <ul
                  v-if="!!getPlanos.sva && getPlanos.sva.mensal && getPlanos.sva.mensal.length > 0 && this.planoSelect !== 4"
                >
                  <li v-for="(p, indice) in getPlanos.sva.mensal" :key="indice">
                    <p class="descricao">
                      {{ montaNomePlano(p) }}
                    </p>
                    <div :class="{ 'valores': !exibirParcelamento, 'valores-parcelamento': exibirParcelamento }">
                      <p class="preco">R$ {{ p.valor | convertMoeda }}</p>
                      <p class="renova">R$ {{ p.descontoRenova | convertMoeda }}</p>
                      <p v-show="exibirParcelamentoTipo" class="parcela">
                          {{oncePrePago && p.plano.parcelamento != null && p.plano.parcelamento.impar_parcela_itaucard !==
                        null && p.plano.parcelamento.impar_parcela_itaucard !== '' ?
                          p.plano.parcelamento.impar_parcela_itaucard + 'x' : '-' }}
                      </p>
                      <p v-if="exibirParcelamento" class="parcela">
                          {{oncePrePago && p.plano.parcelamento != null && p.plano.parcelamento.impar_parcela_cartoes_caixa_santantader_bb !==
                        null && p.plano.parcelamento.impar_parcela_cartoes_caixa_santantader_bb !== '' ?
                          p.plano.parcelamento.impar_parcela_cartoes_caixa_santantader_bb + 'x' : '-' }}
                      </p>
                      <p v-if="exibirParcelamento" class="parcela">
                          {{oncePrePago && p.plano.parcelamento != null &&
                        p.plano.parcelamento.impar_parcela_demais_cartoes !== null &&
                        p.plano.parcelamento.impar_parcela_demais_cartoes !== ''
                          ? p.plano.parcelamento.impar_parcela_demais_cartoes + 'x' : '-' }}
                      </p>
                    </div>
                  </li>
                </ul>
                <ul v-else>
                  <li v-if="oncePrePago">
                    <span>Nenhum plano encontrado.</span>
                  </li>
                </ul>
                <p class="title" v-if="oncePrePago && this.planoSelect !== 4">ANUAL</p>
                <ul v-if="this.planoSelect === 4">
                  <li v-for="(p, indice) in getPlanos.sva.anual" :key="indice">
                    <p class="descricao">{{ p.plano.nome }}</p>
                    <div :class="{ 'valores': !exibirParcelamento, 'valores-parcelamento': exibirParcelamento }">
                      <p class="preco">R$ {{ p.valor | convertMoeda }}</p>
                      <p class="renova">R$ {{ p.descontoRenova | convertMoeda }}</p>
                      <p v-show="exibirParcelamentoTipo" class="parcela">
                          {{ p.plano.parcelamento != null && p.plano.parcelamento.impar_parcela_itaucard !== null &&
                        p.plano.parcelamento.impar_parcela_itaucard !== '' ? p.plano.parcelamento.impar_parcela_itaucard
                          + 'x' : '-' }}
                      </p>
                      <p v-if="exibirParcelamento" class="parcela">
                          {{ p.plano.parcelamento != null && p.plano.parcelamento.impar_parcela_cartoes_caixa_santantader_bb !== null &&
                        p.plano.parcelamento.impar_parcela_cartoes_caixa_santantader_bb !== '' ? p.plano.parcelamento.impar_parcela_cartoes_caixa_santantader_bb
                          + 'x' : '-' }}
                      </p>
                      <p v-if="exibirParcelamento" class="parcela">
                          {{ p.plano.parcelamento != null && p.plano.parcelamento.impar_parcela_demais_cartoes !== null &&
                        p.plano.parcelamento.impar_parcela_demais_cartoes !== '' ?
                          p.plano.parcelamento.impar_parcela_demais_cartoes + 'x' : '-' }}
                      </p>
                    </div>
                  </li>
                </ul>
                <ul v-else-if="!!getPlanos.sva && getPlanos.sva.anual && getPlanos.sva.anual.length > 0 && this.planoSelect !== 4">
                  <li v-for="(p, indice) in getPlanos.sva.anual" :key="indice">
                    <p class="descricao">
                      {{ montaNomePlano(p) }}
                    </p>
                    <div :class="{ 'valores': !exibirParcelamento, 'valores-parcelamento': exibirParcelamento }">
                      <p class="preco">R$ {{ p.valor | convertMoeda }}</p>
                      <p class="renova">R$ {{ p.descontoRenova | convertMoeda }}</p>
                      <p v-show="exibirParcelamentoTipo" class="parcela">
                          {{oncePrePago && p.plano.parcelamento != null && p.plano.parcelamento.impar_parcela_itaucard !==
                        null && p.plano.parcelamento.impar_parcela_itaucard !== ''?
                          p.plano.parcelamento.impar_parcela_itaucard + 'x' : '-' }}
                      </p>
                      <p v-if="exibirParcelamento" class="parcela">
                          {{oncePrePago && p.plano.parcelamento != null && p.plano.parcelamento.impar_parcela_cartoes_caixa_santantader_bb !==
                        null && p.plano.parcelamento.impar_parcela_cartoes_caixa_santantader_bb !== ''?
                          p.plano.parcelamento.impar_parcela_cartoes_caixa_santantader_bb + 'x' : '-' }}
                      </p>
                      <p v-if="exibirParcelamento" class="parcela">
                          {{oncePrePago && p.plano.parcelamento != null &&
                        p.plano.parcelamento.impar_parcela_demais_cartoes !== null &&
                        p.plano.parcelamento.impar_parcela_demais_cartoes !== ''
                          ? p.plano.parcelamento.impar_parcela_demais_cartoes + 'x' : '-' }}
                      </p>
                    </div>
                  </li>
                </ul>
                <ul v-else>
                  <li v-if="oncePrePago">
                    <span>Nenhum plano encontrado.</span>
                  </li>
                </ul>
              </div>

              <div class="list-planos" v-else>
                <p class="title">MENSAL</p>
                <ul v-if="getPlanos.sem.mensal && getPlanos.sem.mensal.length > 0 && this.planoSelect !== 4">
                  <li v-for="(p, indice) in getPlanos.sem.mensal" :key="indice">
                    <p class="descricao">
                      {{ montaNomePlano(p) }}
                    </p>
                    <div :class="{ 'valores': !exibirParcelamento, 'valores-parcelamento': exibirParcelamento }">
                      <p class="preco">R$ {{ p.valor | convertMoeda }}</p>
                      <p class="renova">R$ {{ p.descontoRenova | convertMoeda }}</p>
                      <p v-show="exibirParcelamentoTipo" class="parcela">
                          {{ p.plano.parcelamento != null && p.plano.parcelamento.impar_parcela_itaucard !== null &&
                        p.plano.parcelamento.impar_parcela_itaucard !== '' ? p.plano.parcelamento.impar_parcela_itaucard
                          + 'x' : '-' }}
                      </p>
                      <p v-if="exibirParcelamento" class="parcela">
                          {{ p.plano.parcelamento != null && p.plano.parcelamento.impar_parcela_cartoes_caixa_santantader_bb !== null &&
                        p.plano.parcelamento.impar_parcela_cartoes_caixa_santantader_bb !== '' ? p.plano.parcelamento.impar_parcela_cartoes_caixa_santantader_bb
                          + 'x' : '-' }}
                      </p>
                      <p v-if="exibirParcelamento" class="parcela">
                          {{ p.plano.parcelamento != null && p.plano.parcelamento.impar_parcela_demais_cartoes !== null &&
                        p.plano.parcelamento.impar_parcela_demais_cartoes !== '' ?
                          p.plano.parcelamento.impar_parcela_demais_cartoes + 'x' : '-' }}
                      </p>
                    </div>
                  </li>
                </ul>
                <ul v-else>
                  <li>
                    <span>Nenhum plano encontrado.</span>
                  </li>
                </ul>
                <p class="title">ANUAL</p>
                <ul v-if="getPlanos.sem.anual && getPlanos.sem.anual.length > 0 && this.planoSelect !== 4">
                  <li v-for="(p, indice) in getPlanos.sem.anual" :key="indice">
                    <p class="descricao">
                      {{ montaNomePlano(p) }}
                    </p>
                    <div :class="{ 'valores': !exibirParcelamento, 'valores-parcelamento': exibirParcelamento }">
                      <p class="preco">R$ {{ p.valor | convertMoeda }}</p>
                      <p class="renova">R$ {{ p.descontoRenova | convertMoeda }}</p>
                      <p v-show="exibirParcelamentoTipo" class="parcela">
                          {{ p.plano.parcelamento != null && p.plano.parcelamento.impar_parcela_itaucard !== null &&
                        p.plano.parcelamento.impar_parcela_itaucard !== '' ? p.plano.parcelamento.impar_parcela_itaucard
                          + 'x' : '-' }}
                      </p>
                      <p v-if="exibirParcelamento" class="parcela">
                          {{ p.plano.parcelamento != null && p.plano.parcelamento.impar_parcela_cartoes_caixa_santantader_bb !== null &&
                        p.plano.parcelamento.impar_parcela_cartoes_caixa_santantader_bb !== '' ? p.plano.parcelamento.impar_parcela_cartoes_caixa_santantader_bb
                          + 'x' : '-' }}
                      </p>
                      <p v-if="exibirParcelamento" class="parcela">
                          {{ p.plano.parcelamento != null && p.plano.parcelamento.impar_parcela_demais_cartoes !== null &&
                        p.plano.parcelamento.impar_parcela_demais_cartoes !== ''
                          ? p.plano.parcelamento.impar_parcela_demais_cartoes + 'x' : '-' }}
                      </p>
                    </div>
                  </li>
                </ul>
                <ul v-else>
                  <li>
                    <span>Nenhum plano encontrado.</span>
                  </li>
                </ul>
              </div>
            </div>
            <div class="lista" v-else>
              <nav style="justify-content: end;">
                <div class="labels-vitrine" v-if="planoVitrine !== null">
                  <span style="display: flex; justify-content: end; color: #4E4E4E;">Preço</span>
                </div>
              </nav>
              <div class="list-planos">
                <ul v-if="planoVitrine !== null">
                  <li>
                    <p class="descricao">VITRINE</p>
                    <div style="width: 200px">
                      <p class="preco-vitrine">R$ {{ planoVitrine.valor | convertMoeda }}</p>
                    </div>
                  </li>
                  <li style="margin-top: 4px; color: #4E4E4E; margin-left: 18px;list-style-type:square;">
                    <span>
                      <em>Por enquanto, tabela disponível apenas para Lojas Próprias;</em><br>
                    </span>
                  </li>
                  <li style="margin-top: 4px; color: #4E4E4E; margin-left: 18px;list-style-type:square;">
                    <span>
                      <em>Produtos origem Apple, devem ser faturados apenas para colaboradores Vivo;</em><br>
                    </span>
                  </li>
                  <li style="margin-top: 4px; color: #4E4E4E; margin-left: 18px;list-style-type:square;">
                    <span>
                      <em>Produtos origem Android, podem ser faturados para qualquer cliente;</em><br>
                    </span>
                  </li>
                  <li style="margin-top: 4px; color: #4E4E4E; margin-left: 18px;list-style-type:square;">
                    <span>
                      <em>Consulte a lista de IMEIs disponíveis, no Conteúdos Vivo.</em><br>
                    </span>
                  </li>
                </ul>
                <ul v-else>
                  <li>
                    <span>Nenhum plano encontrado.</span>
                  </li>
                </ul>
              </div>

            </div>
          </div>
          <div class="acessorios" v-else>
            <div class="preco">
              <p>
                <span>R$</span>
                <strong>{{ cel.preco | convertMoeda }}</strong>
              </p>
            </div>
            <div class="parcelamento-container" v-if="exibirParcelamento">
              <div class="parcelamento-title">Parcelamento</div>
              <div class="parcela-container">
                <span class="parcelamento-title-item" v-show="exibirParcelamentoTipo">Vivo Itaúcard</span>
                <span class="parcelamento-title-item">Cartões Caix/Sant/BB</span>
                <span class="parcelamento-title-item">Demais Cartões</span>
              </div>
            </div>
            <div  v-for="(parcelamentoAcessorio, indice) in getParcelamentoAcessorio" :key="indice" class="valores-parcelamento-acessorio">
              <p v-show="exibirParcelamentoTipo" class="parcela">
                {{
                parcelamentoAcessorio.plano.parcelamento != null
                && parcelamentoAcessorio.plano.parcelamento.impar_itaucard != '' && parcelamentoAcessorio.plano.parcelamento.impar_itaucard != null
                ? parcelamentoAcessorio.plano.parcelamento.impar_parcela_itaucard + 'x'
                : '-'
                }}
              </p>
              <p v-if="exibirParcelamento" class="parcela">
                {{
                  parcelamentoAcessorio.plano.parcelamento != null
                  && parcelamentoAcessorio.plano.parcelamento.impar_cartoes_caixa_santantader_bb != '' && parcelamentoAcessorio.plano.parcelamento.impar_cartoes_caixa_santantader_bb != null
                    ? parcelamentoAcessorio.plano.parcelamento.impar_parcela_cartoes_caixa_santantader_bb + 'x'
                    : '-'
                }}
              </p>
              <p v-if="exibirParcelamento" class="parcela">
                {{
                parcelamentoAcessorio.plano.parcelamento != null
                && parcelamentoAcessorio.plano.parcelamento.impar_demais_cartoes != '' && parcelamentoAcessorio.plano.parcelamento.impar_demais_cartoes != null
                ? parcelamentoAcessorio.plano.parcelamento.impar_parcela_demais_cartoes + 'x'
                : '-'
                }}
              </p>
            </div>
          </div>
        </div>

        <div class="conteudo-principal" v-else>
          <div class="imagem-destaque">
            <img src="@/assets/vivo-consulta/imagens/generic_phone_teaser.png" />
            <span>
              <img src="@/assets/vivo-consulta/icones/icone-alerta.svg" class="alerta" alt />
              <p>Imagem meramente ilustrativa</p>
            </span>
          </div>
          <div class="planos">
            <div class="head">
              <h3>Cadastro de Pré Venda</h3>
              <div class="pdv">
                <div class="linha-inputs">
                  <UiSelect
                    :ativo="true"
                    placeholder="PDV"
                    :destaque="true"
                    icone="icone-local-roxo.svg"
                    :options="pdvs"
                    style="flex: 0.7"
                  />
                  <UiSelect
                    :ativo="true"
                    placeholder="UF"
                    :options="ufs"
                    :destaque="true"
                    style="flex: 0.25"
                  />
                </div>
                <h6>
                  <strong>Status:</strong>
                  {{ status }}
                </h6>
              </div>
            </div>
            <div class="cadastro">
              <div class="linha-inputs linha">
                <UiInput
                  label="Nome Completo do Cliente"
                  placeholder="Nome Completo"
                  :tamanhoMax="50"
                  style="flex: 0.69"
                />
                <UiInput
                  label="CPF"
                  placeholder="000.000.000-00"
                  mascara="###.###.###-##"
                  style="flex: 0.29"
                />
              </div>

              <div class="linha-inputs linha">
                <UiInput
                  label="Telefone"
                  placeholder="Telefone"
                  :mascara="['(##)####-####', '(##)#####-####']"
                  style="flex: 0.49"
                />
                <UiInput
                  label="E-mail"
                  placeholder="email@email.com.br"
                  :tamanhoMax="40"
                  style="flex: 0.49"
                />
              </div>

              <div class="linha-inputs linha">
                <UiInput
                  label="CEP"
                  placeholder="00.000-000"
                  mascara="##.###-###"
                  style="flex: 0.42"
                />
                <UiSelect :ativo="true" placeholder="UF" :options="ufs" style="flex: 0.12" />
                <UiInput label="Cidade" placeholder="Cidade" :tamanhoMax="30" style="flex: 0.42" />
              </div>

              <div class="linha-inputs linha">
                <UiInput
                  label="Endereço"
                  placeholder="Endereço com número e complemento"
                  :tamanhoMax="50"
                  style="flex: 0.59"
                />
                <UiInput
                  label="Bairro"
                  placeholder="Nome do Bairro"
                  :tamanhoMax="30"
                  style="flex: 0.39"
                />
              </div>

              <div class="linha-inputs linha">
                <UiTextarea
                  label="Observações"
                  placeholder="Insira alguma observação sobre a reserva..."
                  :tamanhoMax="120"
                  style="flex: 0.69"
                  :altura="'60px'"
                />
                <button type="button" :disabled="estadoBotao">SALVAR</button>
              </div>
            </div>
          </div>
        </div>

        <div class="ficha-tecnica" v-if="cel.esp.length > 0">
          <h2>FICHA TÉCNICA:</h2>
          <ul>
            <li v-for="(esp, index) in cel.esp" :key="index">
              <p>
                <strong>{{ esp.tipo.nome }}:</strong>
                {{ esp.nome }}
              </p>
            </li>
            <li v-if="cel.sku">
              <p>
                <strong>SKU:</strong>
                {{ cel.sku }}
              </p>
            </li>
          </ul>
          <span></span>
        </div>

        <aparelho-similar
          :similares="similares"
          :loading="loadingSimilar"
          :key="!!loadingSimilar"
        />
      </template>
    </section>

    <div class="main-footer-holder">
      <div class="fale-conosco">
        <FaleConosco/>
      </div>

      <MainFooter />
    </div>
    <botao-voltar-topo />
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import Header from '@/components/layout/header/Header.vue';
import MainFooter from '@/components/layout/footer/MainFooter.vue';
import Busca from '@/components/vivo-consulta/header/Busca.vue';
import UiSelect from '@/components/vivo-consulta/ui/UiSelect.vue';
import UiInput from '@/components/vivo-consulta/ui/UiInput.vue';
import UiTextarea from '@/components/vivo-consulta/ui/UiTextarea.vue';
import AparelhoSimilar from '@/components/vivo-consulta/conteudo/AparelhoSimilar.vue';
import CelularDetalhadoImagem from '@/components/vivo-consulta/conteudo/CelularDetalhadoImagem.vue';
import BotaoVoltarTopo from '@/components/BotaoVoltarTopo.vue';
import { clone, includes } from 'lodash';
import env from "../../config/env";
import axios from 'axios';
import FaleConosco from '@/components/layout/conteudo/FaleConosco.vue';

export default {
  name: 'CelularDetalhado',

  components: {
    Header,
    MainFooter,
    Busca,
    UiSelect,
    UiInput,
    UiTextarea,
    CelularDetalhadoImagem,
    AparelhoSimilar,
    BotaoVoltarTopo,
    FaleConosco,
  },

  data() {
    return {
      btnPlanos: [
        { name: 'PRÉ PAGO', id: 2, column: 'pre' },
        { name: 'PORTFÓLIO CONTROLE', id: 3, column: 'controle' },
        { name: 'PORTFÓLIO PÓS / VIVO TOTAL', id: 1, column: 'pos' },
        { name: 'VITRINE', id: 4, column: 'vitrine' },
      ],
      planoSelect: null,
      inputSearch: '',
      estadoBotao: false,
      prevenda: false,
      pdvs: ['PDV1', 'PDV2', 'PDV3'],
      ufs: ['MS', 'MT', 'SP', 'RJ', 'TO'],
      status: 'Pré Lançamento Cadastrado',
      listaAtiva: 'sva',
      numPages: 0,
      pageCurrent: 1,
      numCelularesMin: 0,
      numCelularesMax: 4,
      planoVitrine: null,
      exibirParcelamento: env.revista.canal === env.canal.loja_propria
          || env.revista.canal === env.canal.administrativo,
    };
  },
  computed: {
    ...mapGetters({
      tabela: 'vcTabela/tabela',
      renova: 'vcTabela/renova',
      cel: 'vcModelo/modelo',
      planos: 'vcPlano/planos',
      similares: 'vcModelo/similares',
      loadingModelos: 'vcModelo/loading',
      loadingSimilar: 'vcModelo/loadingSimilar',
      ufId: 'vcUser/ufId',
    }),
    getPlanos() {
      if (this.planoSelect) {
        const { column } = this.btnPlanos.find(p => p.id === this.planoSelect);
        const data = this.planos(column);
        if (this.planoSelect !== 2 && this.planoSelect !== 4 && this.inputSearch && this.inputSearch !== '') {
          const key = this.listaAtiva;
          /**
           * Planos Anuais
           */
          const [anual] =
            data[key].anual !== undefined
              ? [data[key]].map(p =>
                  p.anual.filter(a =>
                    includes(a.plano.nome.toLowerCase(), this.inputSearch.toLowerCase()),
                  ),
                )
              : [];
          /**
           * Planos Mensais
           */
          const [mensal] =
            data[key].mensal !== undefined
              ? [data[key]].map(p =>
                  p.mensal.filter(a =>
                    includes(a.plano.nome.toLowerCase(), this.inputSearch.toLowerCase()),
                  ),
                )
              : [];
          const array = clone(data, true);
          array[key] = { anual, mensal };
          console.log(array);
          return array;
        } else return data;
      }
    },
    oncePrePago() {
      let show = true;
      if (this.planoSelect === 2 || this.planoSelect === 4) {
        this.listaAtiva = 'sva';
        show = false;
      } else {
        show = true;
      }
      return show;
    },
    getParcelamentoAcessorio(){
      const planosPre = this.planos('pre');
      const planosAcessorio = {};
      for (let chave in planosPre) {
        if(planosPre[chave].mensal != undefined){
          planosAcessorio[chave] = planosPre[chave].mensal[0]
        }
      }
      return planosAcessorio;
    },
    exibirParcelamentoTipo() {
      return env.revista.canal !== env.canal.loja_propria && env.revista.canal !== env.canal.administrativo;
    },
  },
  methods: {
    ...mapActions({
      getModelo: 'vcModelo/getModelo',
      setTitle: 'apiRoute/setTitle',
    }),
    proxima() {
      this.numPages = Math.ceil(this.similares.paginate.to / 4);
      if (this.numPages > this.pageCurrent) {
        this.numCelularesMax = this.numCelularesMax + 4;
        this.numCelularesMin = this.numCelularesMin + 4;
        this.pageCurrent = this.pageCurrent + 1;
      } else if (this.numPages == this.pageCurrent) {
        this.numCelularesMax = 4;
        this.numCelularesMin = 0;
        this.pageCurrent = 1;
      }
    },
    anterior() {
      this.numPages = Math.ceil(this.similares.paginate.to / 4);
      if (this.pageCurrent > 1) {
        this.numCelularesMax = this.numCelularesMax - 4;
        this.numCelularesMin = this.numCelularesMin - 4;
        this.pageCurrent = this.pageCurrent - 1;
      } else if (this.numPages == 1) {
        this.numCelularesMax = this.similares.paginate.to;
        this.numCelularesMin = 4 * (this.numPages - 1);
        this.pageCurrent = this.numPages;
      }
    },
    moveCarousel(direction) {
      // Find a more elegant way to express the :style. consider using props to make it truly generic
      if (direction === 1 && !this.atEndOfList) {
        this.currentOffset -= this.paginationFactor;
      } else if (direction === -1 && !this.atHeadOfList) {
        this.currentOffset += this.paginationFactor;
      }
    },
    handleChangeTab(tab) {
      this.listaAtiva = tab;
    },
    handleRedirectPage(tabela) {
      const { page, id } = this.$route.params;
      switch (page) {
        case 'smartphone':
          this.getModelo({
            tabela,
            renova: this.renova,
            modelo: +id,
            tipo: page,
          });
          var URL_TABELA_PRECO_VITRINE = `${process.env.VUE_APP_API_URL}/portal/${this.ufId}/tabela-preco/${id}`;
          fetch(URL_TABELA_PRECO_VITRINE, {
            method: "GET",
          })
            .then((response) => {
              response.json().then((res) => {
                if(res.length > 0){
                  this.planoVitrine = res[0];
                } else {
                  this.planoVitrine = this.ufId;
                }
              });
            })
            .catch((err) => {
              this.planoVitrine = err;
            });
          break;
        case 'acessorios':
          this.getModelo({
            tabela,
            renova: this.renova,
            modelo: id,
            tipo: page,
          });
          break;
        default:
          this.$router.push({ name: 'vivo.consulta.home' });
          break;
      }
    },
    montaNomePlano(p) {
      if (p.plano.sap) {
        return `${p.plano.nome} - (${p.plano.sap})`;
      } else {
        return `${p.plano.nome}`;
      }
    },
  },
  beforeMount() {
    if (this.tabela) this.handleRedirectPage(this.tabela);
    this.$store.subscribe(mutation => {
      const { type, payload } = mutation;
      switch (type) {
        case 'vcTabela/TABELA_ADD':
          this.handleRedirectPage(payload.tabela);
      }
    });

    this.$set(this, 'planoSelect', 2);
  },
  watch: {
    planoSelect(after) {
      if (after) {
        this.$set(this, 'inputSearch', '');
      }
    },
    $route: {
      handler: function(route) {
        this.handleRedirectPage(this.tabela);
      },
    },
    cel(after) {
      if (after) {
        this.setTitle({ title: `${after.modelo} | Vivo Consulta`, system: 2 });
      }
    },
  },
};
</script>

<style scoped lang="scss">
@import '@/estilo/sass/_formulas.scss';
@import '@/estilo/sass/_cores.scss';

.loading-modelo {
  width: 100%;
  min-height: 560px;
  background-color: transparent;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 10px;
}

.home {
  padding-bottom: 50px;
  position: relative;

  & .imagem {
    position: absolute;
    user-select: none;
    height: 335px;
    width: 100%;
    object-fit: cover;
    background: url('./../../assets/vivo-consulta/imagens/pattern-header-reto.jpg');
    background-repeat: no-repeat;
  }
}

.main-holder {
  padding-top: 100px;
}

.main-footer-holder {
  padding: 40px 0px 0px;
  margin-top: 30px;
}

.item-detalhado {
  @extend %area-de-utilizacao;
  width: 100%;
  margin: 0 auto;
  position: relative;
  padding-top: 30px;
  margin-bottom: 100px;
  min-height: 400px;

  ::-webkit-scrollbar-thumb {
    background: #f4f4f4 !important;
  }

  ::-webkit-scrollbar-thumb:hover {
    background: $cor_cinza_medium !important;
  }

  & .nome-do-aparelho {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    border-left: 1px solid white;
    padding-left: 30px;
    margin-left: 5px;
    height: 61px;
    // padding-bottom: 9px;

    & span {
      font-family: 'VivoType';
      font-size: 10px;
      font-weight: 700;
      color: $cor_roxo;
      background: $cor_amarelo;
      padding: 0 20px;
      border-radius: 40px;
      margin: 0px;
      margin-bottom: -3px;
      margin-right: 10px;
    }

    & h1 {
      font-family: 'VivoType';
      font-size: 32px;
      font-weight: 100;
      color: white;
      text-transform: uppercase;
      margin: 0px;
      @media (max-width: 650px) {
        color: #4E4E4E;
      }
    }

    & strong {
      font-family: 'VivoType';
      font-size: 25px;
    }
  }

  & .conteudo-principal {
    width: 100%;
    margin: 0 0 60px 5px;
    padding: 70px 0 0px;
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    align-items: center;
    border-left: 1px solid $cor_roxo;

    @media (max-width: 650px) {
      border-left: 0;
    }

    & .imagem-destaque {
      width: 30%;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      align-self: flex-start;
      position: relative;

      @media (max-width: 650px) {
        width:100%;
        margin-bottom: 20px;
      }


      /* & img {
        user-select: none;
        object-fit: contain;
        max-height: 300px;
        width: auto;
      } */

      & span {
        // display: none !important;
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: center;
        padding-top: 20px;

        & .alerta {
          width: 24px;
          height: 24px;
        }

        & p {
          margin: 0px;
          margin-left: 5px;
          max-width: 60%;
          font-size: 10px;
          font-style: italic;
          color: $cor_cinza_dark;
          line-height: 1.2em;
          font-weight: 600;
        }
      }
    }

    & > .planos {
      width: 70%;
      display: flex;
      flex-direction: column;
      align-self: flex-start;


      @media (max-width: 650px) {
        width:100%;
      }

      & > ul.selecione-planos {
        list-style: none;
        margin: 0;
        padding: 0;
        display: flex;
        flex: 1;
        width: 100%;
        &:after {
          content: '';
          clear: both;
        }
        & li {
          flex: 0 1 100%;
          box-sizing: border-box;
          height: 50px;
          & label {
            display: flex;
            justify-content: center;
            align-items: center;
            width: 100%;
            height: 100%;
            font-family: 'VivoTypeBold', sans-serif;
            font-size: 14px;
            line-height: 15px;
            font-weight: bold;
            border: 0;
            background: #f8f8f8;
            color: #7d7d7d;
            cursor: pointer;
            user-select: none;
            transition: 0.3s all ease-in-out;
            @media (max-width: 650px) {
              font-size: 10px;
            }
          }

          & input[type='radio'] {
            display: none;
            &:checked + label {
              background: #660099;
              color: #fff;
              padding: 0px 5px;
            }
          }
        }
      }

      & > .busca-planos {
        position: relative;
        width: 100%;
        height: 60px;
        background: #f7f7f7;
        box-shadow: inset 0px 0px 10px rgba(0, 0, 0, 0.03);
        border-radius: 0px 0px 5px 5px;

        & input[type='text'] {
          background: transparent;
          position: absolute;
          width: 85%;
          margin: 0;
          padding: 0 20px;
          border: none;
          outline: 0;
          height: 100%;
          font-size: 14px;
          line-height: 19px;
          color: #7d7d7d;
          &::placeholder {
            color: lighten(#7d7d7d, 20%);
          }
        }

        & > img {
          position: absolute;
          right: 20px;
          top: 22px;
        }
      }

      & .foco {
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: center;
        padding: 0px;
        margin: 0px;

        & li {
          display: flex;
          flex-direction: column;
          align-items: center;
          position: relative;
          margin-right: 30px;

          & span {
            color: $cor_amarelo;
            font-size: 14px;
            font-family: 'VivoType';
            font-weight: bold;
            text-transform: uppercase;
            position: absolute;
            top: 0;
            left: 50%;
            margin-top: -20px;
            transform: translate(-50%, 0);
          }

          & > button {
            border: 1px solid #f4f4f4;
            outline: 0;
            font-size: 20px;
            margin: 0px;
            color: $cor_roxo;
            background: #f4f4f4;
            padding: 14px;
            border-radius: 25px;
            transition: all 0.3s ease-in-out;
            &:hover {
              background: darken(#f4f4f4, 10%);
              border-color: $cor_amarelo;
            }
          }

          & p {
            font-size: 28px;
            margin: 0px;
            color: $cor_roxo;
            background: #f4f4f4;
            padding: 7px 14px;
            border-radius: 100px;
          }

          & .destaque {
            background: $cor_amarelo;
          }

          & h4 {
            margin: 0px;
            margin-top: 5px;
            font-size: 12px;
            font-family: 'VivoType';
            font-weight: bold;
            color: $cor_cinza_dark;
          }
        }
      }

      & .lista {
        color: $cor_cinza_dark;
        margin-top: 40px;

        & nav {
          width: 100%;
          border-bottom: 1px solid #f4f4f4;
          display: flex;
          justify-content: space-between;
          align-items: center;

          & .botoes {
            & button {
              background: #f4f4f4;
              font-size: 14px;
              color: $cor_cinza;
              width: 120px;
              font-family: 'VivoType';
              font-weight: bold;
              margin: 0px;
              padding: 0px;
              border-radius: 5px 5px 0 0;
              border: 0px;
              outline: none;
              height: 24px;
            }

            & .ativo {
              background: $cor_roxo;
              color: white;
            }
          }

          & .labels {
              padding-right: 40px;
              width: 200px;
              display: flex;

              & span {
                text-align: right;
                width: 100px;
                font-size: 14px;
                color: $cor_cinza_dark;
                font-family: 'VivoType';
                font-weight: bold;
              }

              & :last-child {
                color: $cor_vivo_verde;
              }
          }

          & .labels-parcelamento {
            display: flex;
            & .renova {
              color: $cor_vivo_verde;
            }

            & span {
              text-align: right;
              width: 70px;
              font-size: 14px;
              color: $cor_cinza_dark;
              font-family: 'VivoType';
              font-weight: bold;
            }

            & .parcelamento-container {
              display: flex;
              flex-direction: column;
              align-items: center;
              text-align: center;
            }

            & .parcelamento-title {
              color: $cor_cinza_dark;
              font-family: 'VivoType';
              font-weight: bold;
              font-size: 14px;
              margin-bottom: 10px;
            }

            & .parcelamento-title-item {
              color: $cor_cinza_dark;
              font-family: 'VivoType';
              font-weight: bold;
              font-size: 12px;
              text-align: center;
              width: 65px;
              font-weight: bold;
              margin-left: 8px;
            }

            & .parcela-container {
              display: flex;
              justify-content: space-around;
            }

            & .renova {
              margin: 0 10px;
              color: $cor_vivo_verde;
            }
          }

          & .labels-vitrine {
            padding-right: 40px;
            width: 200px;
            display: flex;

            & span {
              text-align: right;
              width: 100px;
              font-size: 14px;
              color: $cor_cinza_dark;
              font-family: 'VivoType';
              font-weight: bold;
              margin-left: 40px;
            }
          }
        }

        & > .list-planos {
          width: 100%;
          height: auto;
          & .title {
            background: transparent;
            padding: 15px 25px;
            font-weight: bold;
            font-size: 14px;
            font-family: 'VivoTypeBold', sans-serif;
            line-height: 20px;
            margin: 0;
          }

          & > ul {
            overflow-y: scroll;
            width: 100%;
            margin: 0px;
            padding: 0px;
            @media (min-width: 650px) {
              max-height: 140px;
            }

            & li {
              display: flex;
              flex-direction: row;
              justify-content: space-between;
              font-size: 13px;
              @media (max-width: 500px) {
                font-size: 10px;
              }
               @media (max-width: 330px) {
                font-size: 8px;
              }
              font-family: 'OpenSans';
              font-weight: 600;
              color: $cor_cinza_dark;

              & span {
                padding: 5px 25px;
                font-size: 11px;
                color: #7d7d7d;
                letter-spacing: 1.13px;
              }

              & p {
                margin: 0px;
                padding: 7px 0;
              }

              & .descricao {
                padding-left: 20px;
              }

              & div {
                display: flex;
                flex-direction: row;
                align-items: center;
                padding-right: 30px;
                width: 200px;

                & .preco {
                  width: 100px;
                  text-align: right;
                  font-weight: bold;
                }

                & .renova {
                  width: 100px;
                  text-align: right;
                  color: $cor_vivo_verde;
                  font-weight: bold;
                }

                & .preco-vitrine {
                  width: 100px;
                  text-align: right;
                  font-weight: bold;
                }

                & .renova {
                  width: 92px;
                  text-align: center;
                  color: $cor_vivo_verde;
                  font-weight: bold;
                }
              }

              & .valores {
                display: flex;
                flex-direction: row;
                align-items: center;
                padding-right: 30px;
                width: 200px;

                & .preco-vitrine {
                  width: 100px;
                  text-align: right;
                  font-weight: bold;
                }

                & .preco {
                  width: 100px;
                  text-align: right;
                  font-weight: bold;
                }

                & .renova {
                  width: 100px;
                  text-align: right;
                  color: $cor_vivo_verde;
                  font-weight: bold;
                }
              }

              & .valores-parcelamento {
                display: flex;
                flex-direction: row;
                align-items: center;
                justify-content: flex-end;
                padding-right: 0;
                width: 369px;

                & .preco {
                  width: 80px;
                  text-align: center;
                  font-weight: bold;
                }

                & .preco-vitrine {
                  width: 100px;
                  text-align: right;
                  font-weight: bold;
                }

                & .parcela {
                  width: 54px;
                  text-align: center;
                  font-weight: bold;
                  margin-left: 8px;
                }

                & .renova {
                  width: 92px;
                  text-align: center;
                  color: $cor_vivo_verde;
                  font-weight: bold;
                }
              }
            }

            & li:first-child {
              margin-top: 5px;
            }

            & li:last-child {
              margin-bottom: 5px;
            }

            & li:nth-child(even) {
              background: #f4f4f4;
            }
          }
        }
      }

      & .linha-inputs {
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: space-between;

        & button {
          all: unset;
          border: 1px solid $cor_vivo_verde;
          background: $cor_vivo_verde;
          color: white;
          font-family: 'VivoType';
          font-weight: bold;
          font-size: 18px;
          width: 100%;
          flex: 0.29;
          margin: 0px;
          padding: 0px;
          text-align: center;
          height: 60px;
          border-radius: 5px;
          box-shadow: 0px 10px 20px rgba(46, 205, 80, 0.5);
          transition: all 0.15s ease-in-out;

          &:hover {
            transform: scale(1.05);
            margin-top: -10px;
            box-shadow: 0px 20px 40px rgba(46, 205, 80, 0.25);
          }

          &:disabled {
            background: $cor_cinza_medium;
            border-color: $cor_cinza_medium;
            color: $cor_cinza;
            box-shadow: none;

            &:hover {
              transform: none;
              margin-top: 0;
              box-shadow: none;
            }
          }
        }
      }

      & .linha {
        padding: 10px 0;
      }

      & .head {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: flex-start;
        z-index: 1;
        width: 100%;

        & h3 {
          font-family: 'VivoType';
          font-weight: bold;
          font-size: 28px;
          text-transform: uppercase;
          padding-top: 5px;
          margin: 0px;
          color: $cor_roxo;
          flex: 0.5;
        }

        & .pdv {
          flex: 0.45;

          & h6 {
            font-style: italic;
            font-size: 11px;
            font-weight: 400;
            color: $cor_cinza_dark;
            margin: 5px 0 0;
            text-align: right;
          }
        }
      }

      & .cadastro {
        margin-top: 20px;
      }
    }

    & > .acessorios {
      height: 300px;
      display: flex;
      flex-direction: column;
      justify-content: center;

      & .parcelamento-container {
        display: flex;
        flex-direction: column;
        align-items: center;
        text-align: center;
      }

      & .parcelamento-title {
        color: $cor_cinza_dark;
        font-family: 'VivoType';
        font-weight: bold;
        font-size: 16px;
        margin-bottom: 10px;
      }

      & .parcelamento-title-item {
        color: $cor_cinza_dark;
        font-family: 'VivoType';
        font-weight: bold;
        font-size: 14px;
        text-align: center;
        width: 72px;
        font-weight: bold;
        margin-left: 10px;
      }

      & .parcela-container {
        display: flex;
        justify-content: space-around;
      }

      & .preco {
        & p {
          background: #ff9900;
          width: auto;
          padding: 30px;
          border-radius: 10px;
          font-family: OpenSans;
          font-style: normal;
          font-weight: normal;
          font-size: 42px;
          line-height: 57px;
          color: #660099;
          transition: 0.3s all ease-in-out;
          & span {
            margin-right: 10px;
          }

          &:hover {
            background: lighten(#ff9900, 10%);
            color: lighten(#660099, 10%);
          }
        }
      }

      & .valores-parcelamento-acessorio {
        display: flex;
        flex-direction: row;
        align-items: center;
        padding-right: 0;
        align-self: center;

        & .preco {
          width: 80px;
          text-align: center;
          font-weight: bold;
        }

        & .preco-vitrine {
          width: 100px;
          text-align: right;
          font-weight: bold;
        }

        & .parcela {
          width: 82px;
          text-align: center;
          font-weight: bold;
          margin-left: 6px;
        }

        & .renova {
          width: 92px;
          text-align: center;
          color: $cor_vivo_verde;
          font-weight: bold;
        }
      }
    }
  }

  & .ficha-tecnica {
    background: #f4f4f4;
    padding: 30px 50px 40px;
    border-radius: 15px;
    position: relative;

    & h2 {
      font-size: 22px;
      font-family: 'VivoType';
      font-weight: bold;
      color: $cor_roxo;
    }

    & ul {
      width: 100%;
      display: flex;
      flex-direction: row;
      flex-wrap: wrap;
      align-items: center;
      justify-content: space-between;
      margin: 20px 0 0;
      padding: 0px;

      & li {
        margin: 4px 0;
        width: 31%;
        @media (max-width: 650px) {
          width: 50%;
        }
        @media (max-width: 380px) {
          width: 100%;
        }
        & p {
          font-size: 15px;
          color: $cor_cinza;
          margin: 0px;
          @media (max-width: 450px) {
            font-size: 11px;
          }
        }

        & strong {
          font-size: 16px;
          font-family: 'VivoType';
          font-weight: bold;
          @media (max-width: 450px) {
            font-size: 12px;
          }
        }
      }
    }

    & span {
      width: calc(100% - 100px);
      position: absolute;
      bottom: 0;
      background: $cor_cinza_medium;
      height: 4px;
      border-radius: 4px 4px 0 0;
    }
  }

  & .similares {
    margin: 70px 0;

    & h2 {
      font-size: 22px;
      font-family: 'VivoType';
      font-weight: bold;
      color: $cor_roxo;
      text-align: center;
    }
    .botao-nav {
      display: flex;
      font-size: 40px;
      margin-top: 70px;
    }
    & .relacionados {
      display: flex;
      flex: 0.33;
      flex-direction: row;
      align-items: flex-start;
      justify-content: space-between;
      align-self: flex-start;
      margin: 0 auto;
      margin-top: 50px;
      max-width: 980px;
      height: auto;
      padding: 0;

      .celular {
        width: 230px;
      }

      & a {
        user-select: none;
        text-decoration: none;
        display: flex;
        flex-direction: column;
        align-items: stretch;
        justify-content: center;
        margin: 0px;
        margin-bottom: 50px;
        // height: 300px;
        transition: all 0.2s ease-in-out;
        color: $cor_cinza_darkest;

        & .foto {
          display: flex;
          align-items: center;
          justify-content: center;

          & img {
            height: 180px;
            object-fit: contain;
            width: auto;
          }
        }

        & .informacoes {
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;

          & h3 {
            font-family: 'VivoType';
            text-align: center;
            color: $cor_cinza_dark;
            font-weight: 300;
            font-size: 16px;
            margin: 10px 0 0;
            max-width: 90%;
            line-height: 1em;
            text-transform: uppercase;

            & strong {
              font-family: 'VivoType';
            }
          }

          & p {
            color: $cor_cinza_dark;
            font-size: 24px;
            margin: 0px;
            font-weight: 100;

            & strong {
              font-weight: 700;
            }
          }
        }

        &:hover {
          transform: scale(1.1);
          margin-top: -10px;
          // perspective: 100px;
          // transform: rotateY(360deg);
          // transform-style: preserve-3d
        }

        // &::after {
        //   content: "";
        //   flex: 0 0 380px;
        // }
      }

      & .com-filtro {
        //width: 25%;
      }

      & .sem-filtro {
        width: 20%;
      }
    }
  }
}
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.1s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active em versões anteriores a 2.1.8 */ {
  opacity: 0;
}

.cx-celulares {
  display: flex;
  flex-direction: row;
  justify-content: center;
}
</style>
